import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConnectedRouter } from "connected-react-router";
import { ConfigProvider } from "antd";

import { history, persistor, store } from "../../appRedux/store/Store";
import LanguageProvider from "../../lngProvider/LanguageProvider.jsx";
import ThemeProvider from "../../util/ThemeProvider/ThemeProvider.jsx";
import ChatProvider from "../../context/ChatContext/ChatContext";
import FormV3Provider from "../../context/FormV3Context/FormV3Context";
import { RegistryProviders } from "../../context/RegistryContexts/providers";
import { FastActionsProvider } from "../Widgets/InfiniteListWidget/FastActionsContext/FastActionContext";

export function BaseProviders({ children, includeConfigProvider = false, includeRouter = true }) {
   const content = (
      <Provider store={store}>
         <PersistGate loading={null} persistor={persistor}>
            {includeRouter ? (
               <ConnectedRouter history={history}>
                  <ProvidersChain>{children}</ProvidersChain>
               </ConnectedRouter>
            ) : (
               <ProvidersChain>{children}</ProvidersChain>
            )}
         </PersistGate>
      </Provider>
   );

   if (includeConfigProvider) {
      return (
         <ConfigProvider
            getPopupContainer={(triggerNode) =>
               triggerNode.closest(".bp2legacy") ||
               document.getElementById("dropdown-root") ||
               document.body
            }
         >
            {content}
         </ConfigProvider>
      );
   }

   return content;
}

function ProvidersChain({ children }) {
   return (
      <LanguageProvider>
         <ThemeProvider>
            <ChatProvider>
               <FormV3Provider>
                  <RegistryProviders>
                     <FastActionsProvider>{children}</FastActionsProvider>
                  </RegistryProviders>
               </FormV3Provider>
            </ChatProvider>
         </ThemeProvider>
      </LanguageProvider>
   );
}
